// State serialization utilities for URL sharing
export interface SerializableConfig {
  bed: {
    slug: string | null
    selectedSize: number | null
  }
  textile: { id: number | string } | null
  legs: { id: number } | null
  headboard: { id: number } | null
  topper: { id: number } | null
  bedsideTable: { id: number } | null
  ottoman: { id: number } | null
  accessories: Array<{ id: number }>
  textileTextureId?: number | null
  legTextureId?: number | null
  legTypeId?: number | null
  topperTextureId?: number | null
  bedsideTableTextureId?: number | null
  preferSeamless?: boolean
}

export function serializeBedConfig(bedConfig: any, market: string, lang: string, preferSeamless?: boolean): string {
  const config: SerializableConfig = {
    bed: {
      slug: bedConfig.bed.variation?.slug || null,
      selectedSize: bedConfig.bed.selectedSize || null,
    },
    textile: bedConfig.textile ? { id: bedConfig.textile.id } : null,
    legs: bedConfig.legs ? { id: bedConfig.legs.id } : null,
    headboard: bedConfig.headboard ? { id: bedConfig.headboard.id } : null,
    topper: bedConfig.topper ? { id: bedConfig.topper.id } : null,
    bedsideTable: bedConfig.bedsideTable ? { id: bedConfig.bedsideTable.id } : null,
    ottoman: bedConfig.ottoman ? { id: bedConfig.ottoman.id } : null,
    accessories: (bedConfig.accessories || []).map((acc: any) => ({ id: acc.id })),
    textileTextureId: bedConfig.textile?.currentTexture?.id || null,
    legTextureId: bedConfig.legs?.currentTexture?.id || null,
    legTypeId: bedConfig.legs?.legTypeId || null,
    topperTextureId: bedConfig.topper?.currentTexture?.id || null,
    bedsideTableTextureId: bedConfig.bedsideTable?.currentTexture?.id || null,
    preferSeamless: preferSeamless !== undefined ? preferSeamless : undefined,
  }
  
  // Include market and lang in the config
  const fullConfig = { ...config, market, lang }
  
  // Convert to JSON and encode as base64
  const json = JSON.stringify(fullConfig)
  // Use base64url encoding (URL-safe)
  return btoa(json).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')
}

export function deserializeBedConfig(encoded: string): { config: SerializableConfig; market: string; lang: string } | null {
  try {
    // Decode base64url
    const base64 = encoded.replace(/-/g, '+').replace(/_/g, '/')
    const json = atob(base64)
    const parsed = JSON.parse(json)
    
    return {
      config: {
        bed: parsed.bed,
        textile: parsed.textile,
        legs: parsed.legs,
        headboard: parsed.headboard,
        topper: parsed.topper,
        bedsideTable: parsed.bedsideTable,
        ottoman: parsed.ottoman,
        accessories: parsed.accessories || [],
        textileTextureId: parsed.textileTextureId,
        legTextureId: parsed.legTextureId,
        legTypeId: parsed.legTypeId || parsed.legs?.legTypeId,
        topperTextureId: parsed.topperTextureId,
        bedsideTableTextureId: parsed.bedsideTableTextureId,
        preferSeamless: parsed.preferSeamless,
      },
      market: parsed.market || 'se',
      lang: parsed.lang || 'sv',
    }
  } catch (error) {
    console.error('Failed to deserialize config:', error)
    return null
  }
}

